export default __webpack_public_path__ + "static/media/support-mail-icon.b8df5d4e.svg";